var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"input-field",attrs:{"block":"","hide-details":"auto","label":_vm.option.name,"items":_vm.option.options,"outlined":"","multiple":_vm.option.multiple,"loading":_vm.loading,"value":_vm.selectedOptions},on:{"change":_vm.updated},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('div',{domProps:{"innerHTML":_vm._s(item.text)}})]}},{key:"selection",fn:function(ref){
var item = ref.item;
return [_c('div',{domProps:{"innerHTML":_vm._s(item.text)}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }